import { useContext } from 'react';
import AppSettingsContext from '@/contexts/AppSettingsContext';

/**
 * Registration validation error codes.
 * These constants are synchronized with the backend ValidationErrorCodes
 * that are returned from the GetAppSettings endpoint.
 * 
 * @see GetAppSettingsResponse.ValidationErrorCodes
 */

export interface IValidationErrorCodes {
    freeSponsorRegistrationsExhausted?: string | undefined;
}

/**
 * Hook to get validation error codes from app settings.
 * Falls back to hardcoded values if not loaded from backend yet.
 */
export const useValidationErrorCodes = (): IValidationErrorCodes => {
    const appSettings = useContext(AppSettingsContext);
    
    // Return from backend if available, otherwise fallback to hardcoded
    return appSettings?.data?.validationErrorCodes ?? {
        // ... existing hardcoded fallback values ...
        freeSponsorRegistrationsExhausted: 'REG-025'
    };
};
